import {
  Card,
  Col,
  Progress,
  Radio,
  Row,
  Select,
  Skeleton,
  Tabs,
  Typography,
  Descriptions,
  Table,
  Tag,
  Badge,
  Tooltip,
  Dropdown,
  Menu,
  Button,
} from "antd";

import {
  CategoryChallengePieChart,
  DurationChallengePieChart,
  EmotionChallengePieChart,
} from "../../components/Chart/ChallengePieChart";

import { DownOutlined } from "@ant-design/icons";
import React, { useContext, useEffect, useState } from "react";
import { LineChart, Line, XAxis, YAxis, CartesianGrid, Legend } from "recharts";

import apiPath from "../../constants/apiPath";
import { AppStateContext } from "../../context/AppContext";
import { Severty, ShowToast } from "../../helper/toast";
import useRequest from "../../hooks/useRequest";
import { useNavigate } from "react-router";
import { useAuthContext } from "../../context/AuthContext";
import { Link } from "react-router-dom";
import "../../assets/styles/dashboard.css";
import moment from "moment";
import ImportForm from "../../components/ImportForm";

import LogoImage from "../../assets/images/logo.svg";

import DashbordIcon from "../../assets/images/dashbord-image/dashbord.png";
import NotificationIcon from "../../assets/images/notification.svg";
import AppUpdatesIcon from "../../assets/images/dashbord-image/App-Updates.png";
import ChallengeManagementIcon from "../../assets/images/dashbord-image/Challenge-Management.png";
import ContentModerationIcon from "../../assets/images/dashbord-image/Content-Moderation.png";
import LeaderboardIcon from "../../assets/images/dashbord-image/Leaderboard.png";
import ReportingManagementIcon from "../../assets/images/dashbord-image/Reporting-Management.png";
import SecurityIcon from "../../assets/images/dashbord-image/Security.png";
import StoreManagementIcon from "../../assets/images/dashbord-image/Store-Management.png";
import UserEngagementIcon from "../../assets/images/dashbord-image/User-Engagement.png";
import UserManagementIcon from "../../assets/images/dashbord-image/User-Management.png";
import VideoManagementIcon from "../../assets/images/dashbord-image/Video-Management.png";
import NewHeader from "../../components/layout/NewHeader";

const { Title, Text } = Typography;

const years = [2024, 2025];

function DashboardIndex() {
  const { setPageHeading, country } = useContext(AppStateContext);

  const { request } = useRequest();
  const [loading, setLoading] = useState(false);
  const [refresh, setRefresh] = useState(false);
  const [importModal, showImportModal] = useState(false);
  const [year, setYear] = useState(years[0]);
  const [period, setPeriod] = useState("monthly");
  const { userProfile } = useAuthContext();
  const [dashboard, setDashboard] = useState();
  const [listing, setListing] = useState([]);
  const [stockData, setStockData] = useState([]);
  const [extraKeys, setExtraKeys] = useState({});
  const [openPosition, setOpenPositions] = useState();
  const [currency, setCurrency] = useState("USD");


  const data = [
    { name: "Jan", uv: 4000, pv: 2400, amt: 2400 },
    { name: "Feb", uv: 3000, pv: 1398, amt: 2210 },
    // Add more data points
  ];

  const orders = [
    {
      title: "Order id",
      dataIndex: "index",
      key: "index",
      render: (_, { order_id }) =>
        order_id ? <span className="cap">#{order_id}</span> : "-",
    },
    {
      title: "Customer Name",
      dataIndex: "name",
      key: "name",
      render: (_, { user_id }) =>
        user_id ? (
          <div style={{ display: "flex", gap: 2, flexDirection: "column" }}>
            {user_id?.name && <span className="cap">{user_id.name}</span>}
            {user_id?.country_code && user_id?.mobile_number && (
              <span className="cap" style={{ fontSize: "14px", color: "gray" }}>
                (
                {user_id.country_code?.includes("+")
                  ? user_id.country_code
                  : "+" + user_id.country_code}
                ) {user_id.mobile_number}
              </span>
            )}
            {user_id?.email && (
              <span style={{ fontSize: "14px", color: "gray" }}>
                {user_id.email}
              </span>
            )}
          </div>
        ) : (
          "-"
        ),
      sorter: (a, b) => {
        let nameA = a.user_id?.name;
        let nameB = b.user_id?.name;
        if (nameA < nameB) return -1;
        if (nameA > nameB) return 1;
        return 0;
      },
    },
    {
      title: "Total Amount",
      dataIndex: "amount",
      key: "amount",
      render: (_, { amount }) => (
        <span className="cap">{amount?.toFixed(2) ?? 0.0}</span>
      ),
      sorter: (a, b) => {
        let nameA = a.amount;
        let nameB = b.amount;
        if (nameA < nameB) return -1;
        if (nameA > nameB) return 1;
        return 0;
      },
    },
    {
      title: "Order Date",
      key: "created_at",
      dataIndex: "created_at",
      render: (_, { created_at }) => {
        return (
          <span>
            {moment(created_at).format("ll")},{" "}
            {moment(created_at).format("HH:mm a")}
          </span>
        );
      },
      sorter: (a, b) => a.created_at?.localeCompare(b?.created_at),
    },
  ];

  useEffect(() => {
    setPageHeading("Welcome Admin");
    if (!userProfile) return;

    setLoading(true);
    request({
      url: apiPath.dashboard + `${year ? `?year=${year}` : ""}`,
      method: "GET",
      onSuccess: ({ data }) => {
        setLoading(false);
        setListing(data?.orders);
        setDashboard(data?.data);
        setExtraKeys(data?.extraKeys?.[0]);
      },
      onError: (error) => {
        setLoading(false);
        ShowToast(error, Severty.ERROR);
      },
    });
  }, [userProfile, refresh]);

  const [isOpen, setIsOpen] = useState(false);

  const toggleSidebar = () => {
    setIsOpen(!isOpen);
  };



  return (
    <>
      <div className="dashboard-section">
        <div className="container">
          <div className="main-card-section">
            <NewHeader />
            <Card className="criclebox mt-3">
              <div className="userid-no">
                <h6>User Id</h6>
              </div>
              <div className="page-top-space home-card layout-content">
                <div className="mb-24">
                  <Row className="mt-3" gutter={[24, 24]}>
                    <Col span={24}>
                      <Card
                        bordered={false}
                        className="criclebox tablespace mb-24"
                      >
                        <p className="dashboard-table-heading">
                          Recent Orders (10){" "}
                        </p>
                        <div className="table-responsive">
                          <Table
                            loading={loading}
                            columns={orders}
                            dataSource={listing}
                            pagination={false}
                            className="ant-border-space"
                          />
                        </div>
                      </Card>
                    </Col>
                    <Col xs={24} sm={24} md={12}>
                      <div className="card">
                        <h3>Candle Stick Chart</h3>
                        <LineChart width={440} height={300} data={data}>
                          <CartesianGrid strokeDasharray="3 3" />
                          <XAxis dataKey="name" />
                          <YAxis />
                          <Tooltip />
                          <Legend />
                          <Line type="monotone" dataKey="pv" stroke="#8884d8" />
                          <Line type="monotone" dataKey="uv" stroke="#82ca9d" />
                        </LineChart>
                      </div>
                    </Col>
                    <Col xs={24} sm={24} md={12}>
                      <div className="card">
                        <h3>Candle Stick Chart</h3>
                        <LineChart width={440} height={300} data={data}>
                          <CartesianGrid strokeDasharray="3 3" />
                          <XAxis dataKey="name" />
                          <YAxis />
                          <Tooltip />
                          <Legend />
                          <Line type="monotone" dataKey="pv" stroke="#8884d8" />
                          <Line type="monotone" dataKey="uv" stroke="#82ca9d" />
                        </LineChart>
                      </div>
                    </Col>
                  </Row>
                 
                </div>
              </div>
            </Card>
          </div>
        </div>
      </div>
    </>
  );
}

export default DashboardIndex;
